import { AddMatchVideo as AddMatchVideoComponent } from './AddMatchVideo.component';
import { connector } from './AddMatchVideo.connector';

export const AddMatchVideo = connector(AddMatchVideoComponent);
